<template>
  <div
    class="card"
    :class="{blue:blue, orange:orange}"
  >
    <slot />
  </div>
</template>

<script>
export default {
	name: "BrCard",
	props:{
		blue:{
			type: Boolean,
			default: false
		},
		orange:{
			type: Boolean,
			default: false
		},
	},
	data() {
		return {}
	},
	mounted() {

	},
	methods: {}
}
</script>
<style lang="scss" scoped>
@use "../../scss/_variables.scss";

	.card{
		border: thin solid #dddddd;
		border-radius: 15px;
		padding: 18px;
		background-color: variables.$color-background;
		&.orange{
			border-color: variables.$color-card-border-orange;
		}
		&.blue{
			border-color: variables.$color-card-border-blue;
		}
	}
</style>